export const osnTop106SIcon = {
  data: `<svg viewBox="0 0 280 211" fill="none" xmlns="http://www.w3.org/2000/svg"><path opacity="0.5" d="M9.52002
108.04C9.52002 160.68 33.32 204.36 90.16 204.36C132.72 204.36 161.56 176.64 161.56 140.24C161.56 100.48 131.6 80.0399
98 80.0399C77.56 80.0399 58.8 91.2399 50.12 103.84C49.84 102.72 49.84 101.32 49.84 99.9199C49.84 70.24 68.32 45.8799
96.6 45.8799C113.12 45.8799 123.76 51.1999 133.84 60.7199L151.76 30.7599C138.32 19.2799 119.28 11.4399 96.6
11.4399C41.44 11.4399 9.52002 51.4799 9.52002 108.04ZM121.24 141.92C121.24 155.08 109.76 169.64 88.2 169.64C61.88
169.64 51.8 148.92 50.12 131C59.08 120.08 72.52 113.08 86.52 113.08C104.72 113.08 121.24 121.76 121.24 141.92Z"
fill="#0F0125" stroke="currentColor" stroke-width="13"/></svg>`,
  name: 'top-10-6-s',
};
